// -----------------------------------------------
// Kamilune Reviews – STATIC VERSION
// Photos for first 29 reviews only
// -----------------------------------------------

const KR_REVIEWS_PER_PAGE = 5;

// Fotos automáticas para las primeras 27
const photoList = Array.from({ length: 31 }, (_, i) =>
  `https://cdn.shopify.com/s/files/1/1005/7380/6868/files/R_${i + 1}.jpg?v=1776886015` 
);
//colocar esto: https://cdn.shopify.com/s/files/1/0702/9017/8138/files/Review_${i + 1}.webp?v=1766511911 entre las comillas únicas de arriba para poner imágenes

// Lista fija de nombres
const names = [
  "Sarah R", "Emily M", "Olivia L", "Michael S", "Sophia K", "Emma T", "Grace B", "Charlotte P",
  "Ava V", "James J", "Madison H", "Hannah C", "Elizabeth F", "Lily D", "Benjamin G", "Abigail W",
  "Amelia N", "Mia Z", "Isabella E", "Julia O", "David Q", "Rachel Y", "Jennifer U", "Laura A",
  "Jessica R", "Andrew M", "Katie L", "Claire S", "Amy K", "Anna T", "Rebecca B",
  "Daniel P", "Nicole V", "Catherine J", "Allison H", "Natalie C", "Matthew F", "Samantha D",
  "Ashley G", "Eva W", "Chloe N", "Ryan Z", "Brooke E", "Melissa O", "Lauren Q",
  "Taylor Y", "Amanda U", "Rachel A", "Morgan R", "Joshua M", "Paige L", "Caroline S",
  "Lindsay K", "Danielle T", "Natalie B", "Ethan P", "Alexis V", "Megan J", "Patricia H",
  "Julia C", "Ella F", "Alexander D", "Hailey G", "Kimberly W", "Tiffany N", "Kaylee Z",
  "Barbara E", "Elise O", "Maya Q", "Philip Y", "Carmen U", "Cecilia A", "Olivia R",
  "Alicia M", "Nicholas L", "Iris S", "Lauren K", "Margaret T", "Rebecca B", "Adrian P",
  "Victoria V", "Camila J", "Robert H", "Melissa C", "Grace F", "Mercedes D",
  "Mary Jane G", "Faith W", "Ada N", "Elsa Z", "Martin E", "Monica O", "Diana Q",
  "Nora Y", "Marina U", "Constance A", "Isabel R", "Gabriel M", "Trinity L", "Amber S"
];

// Lista fija de nombres en Español
const namesES = [
  "María R", "Sofía M", "Valentina L", "Diego S", "Isabella K", "Victoria T", "Luna B", "Martina P",
  "Ariana V", "Mateo J", "Paula H", "Daniela C", "Renata F", "Emma D", "Santiago G", "Abril W",
  "Amelia N", "Mia Z", "Antonella E", "Julia O", "Carlos Q", "Carla Y", "Alejandra U", "Sara A",
  "Josefina R", "Andrés M", "Agustina L", "Clara S", "Jimena K", "Alma T", "Mariana B",
  "Sebastián P", "Florencia V", "Catalina J", "Irene H", "Ainhoa C", "Lucas F", "Malena D",
  "Rocío G", "Eva W", "Lola N", "Miguel Z", "Bianca E", "Gabriela O", "Ximena Q",
  "Camila Y", "Samantha U", "Elisa A", "Alondra R", "Javier M", "Pilar L", "Carolina S",
  "Claudia K", "Daniela T", "Natalia B", "Emiliano P", "Abril V", "Maritza J", "Patricia H",
  "Julieta C", "Mila F", "Alejandro D", "Paloma G", "Paola W", "Tamara N", "Nayla Z",
  "Bárbara E", "Elisa O", "Amaya Q", "Felipe Y", "Carmen U", "Celia A", "Olivia R",
  "Alicia M", "Nicolás L", "Iris S", "Lorena K", "Margarita T", "Rebeca B", "Adriana P",
  "Verónica V", "Camila J", "Rafael H", "Marisol C", "Guadalupe F", "Mercedes D",
  "María José G", "Fátima W", "Aida N", "Elsa Z", "Martín E", "Mónica O", "Dayana Q",
  "Nerea Y", "Marina U", "Consuelo A", "Isidora R", "Gabriel M", "Trinidad L", "Amparo S"
];

// Lista fija de textos (idéntica a tu original)
const baseTexts = [
'My couch is finally safe! Worth every penny.',
'No more 3 am wake-ups. I sleep through the night now.',
'I thought it wasnt possible but our litter box problems are gone after years of struggling.',
'My wifes cat stopped bitting my dog and thats awesome',
'We have a long way to go but just a few days and Milo already comes when I call him. This is definitely worth it!',
'The two cats stopped fighting each other. Peace at last.',
'Ive learned that the space was the issue my cats no longer destroy things out of boredom.',
'It was easy to understand and we got rid of 4am meowing.',
'Fixed the litter box issue in days. Amazing.',
'Kitten stopped attacking my feet. Finally.',
'The furniture scratching is completely gone.',
'My cat tolerates guests now. Huge improvement.',
'Midnight zoomies are finally under control.',
'Nail clipping without a fight. Never thought possible.',
'No more curtain climbing. Curtains are intact.',
'The cats get along now. Did not think it was possible.',
'Vet trips are manageable now. Big difference.',
'He lets me pick him up without scratching. Finally.',
'So much quieter during work calls now.',
'All my plants are still alive. Miracle.',
'Cat stopped bolting outside every time I open the door.',
'The laundry pile peeing stopped. So relieved.',
'My cat is much gentler with my kids now.',
'Whole house sleeps through the night. Game changer.',
'Guests can actually pet her now.',
'He is calmer and happier. Totally different cat.',
'Litter box issues gone. One of my best purchases.',
'No more surprise bites during cuddle time with our dog.',
'My kids can pet her now, I disvered that she didnt hate us.',
'The vet no longer has to force our cat onto the table to examine him — it used to be so stressful. Such a relief.',
'Vet visits are so much less stressful now.',
'Ankle attacks are history. So glad I found this.',
'She waits quietly in the mornings now.',
'My cat is so much better with strangers.',
'He stopped knocking things off shelves. Finally.',
'Carpet scratching completely stopped.',
'No more food stealing. Boundaries work.',
'The cats coexist peacefully now.',
'So much quieter and calmer during the day.',
'We both sleep properly now. Love this guide.',
'Cable chewing stopped. Huge relief.',
'Morning ankle attacks are gone.',
'Wallpaper is finally safe.',
'Vet visits no longer a nightmare.',
'Stress peeing completely resolved.',
'Counter surfing stopped. Kitchen is mine again.',
'She no longer destroys my stuff when I leave.',
'He is calm around the dog now. Unbelievable.',
'No more food obsession. She eats normally.',
'Scratching the door at night stopped completely.',
'My arms healed. No more play biting.',
'She actually responds to me now. Love it.',
'The aggression is completely gone.',
'He uses the litter box every single time now.',
'Morning chaos stopped. Peaceful house.',
'No more hissing at visitors.',
'She stopped waking me up. Best purchase ever.',
'Furniture scratching is a thing of the past.',
'He stopped spraying after I applied this.',
'The night crazies stopped. We all sleep now.',
'No more accidents outside the box.',
'She plays without going overboard now.',
'My cat is a different animal. In the best way.',
'He stopped destroying the blinds. Finally.',
'Biting during petting completely stopped.',
'She uses her post exclusively now.',
'No more stolen food. Boundaries established.',
'He coexists with the dog peacefully now.',
'Morning meowing gone. Bliss.',
'She stopped scratching guests. Huge win.',
'Litter box habits are perfect now.',
'No more midnight sprints around the house.',
'He stopped chewing cables. Such a relief.',
'She no longer hides from everyone.',
'The fighting between my cats stopped.',
'No more destroyed plants. Finally.',
'He is so much calmer and easier to live with.',
'She stopped bolting outside. Peace of mind.',
'No more waking up with a cat on my face.',
'Ankle attacks completely gone.',
'My cat listens now. Honestly impressive.',
'She uses the carrier without panicking now.',
'Furniture is intact. Cannot believe it worked.',
'He stopped meowing all day for attention.',
'No more litter box drama. So relieved.',
'She is gentle now. Totally different behavior.',
'My cat and I finally understand each other.',
'No more scratching the wallpaper. Amazing.',
'He stopped waking the whole house at night.',
'She plays nicely now. No more scratches.',
'Best thing I bought for my cat this year.',
'No more accidents. Litter box is used perfectly.',
'He stopped stealing food off the counter.',
'She no longer attacks feet. What a relief.',
'My cat is calmer, happier and easier to live with.',
'No more destroyed curtains. Life is good.',
'He coexists with our other cat now. Miracle.',
'She stopped the 3am meowing. I finally rest.',
'No more furniture damage. Highly recommend.',
'My cat actually behaves now. Still surreal.',
'She stopped going outside the box completely.',
'He is so much less aggressive. Great guide.',
'No more biting during play. Finally.',
'My cat is a joy to live with now. Thank you.'
];

// Lista fija de traducciones de reviews al Español
const baseTextsES = [
'Me encantó este relojito! Los ojitos de píxeles son hermosísimos, mi hija no quiere dejar de mirarlo. La pantalla muestra diferentes caritas y es súper interactivo. Se agita para posponer la alarma y responde al sonido, realmente es adorable. Perfecto para que los niños aprendan a despertarse solos.',
'Funciona increíble, justo lo que necesitaba para mi hijo. La pantalla de píxeles muestra corazones, ojitos y hasta se ve dormido en la noche. Responde al sonido y la lámpara integrada es muy práctica. Se puede agitar para posponer y eso le encanta a mi niño.',
'Qué compra tan acertada! El diseño es precioso, parece un juguete de alta gama. La pantalla con los píxeles es adorable, muestra diferentes expresiones que entretienen a mi hija. La función de lámpara que responde al sonido es genial para la noche. Muy recomendado para niños sin teléfono.',
'Excelente producto. Lo compré para mi hija de 8 años y está fascinada. Los ojitos de píxeles cambian de expresión, muestra hasta la temperatura y la batería. La lámpara se activa con sonido y se puede posponer la alarma agitándolo. Funciona perfecto.',
'Superó mis expectativas completamente. La pantalla de píxeles es preciosa y muy expresiva, muestra corazones, ojitos confundidos cuando lo agitas. La función de responder al sonido lo hace súper interactivo. Mi hijo ya no necesita que lo despierte, totalmente recomendado.',
'Me fascina. Es adorable, interactivo y muy funcional. La pantalla muestra diferentes símbolos lindos y la lámpara responde al sonido. Perfecto para niños.',
'Hermoso y práctico. Los píxeles muestran expresiones tiernas y responde al sonido. La función de agitar para posponer es genial. Mi hija lo adora.',
'Estoy encantada con esta compra. Es súper lindo y funcional. Los ojitos de píxeles son adorables. Mi hijo está feliz con su reloj.',
'Producto de excelente calidad. La pantalla de píxeles es hermosa y muy clara. Las expresiones son tiernas y la lámpara integrada es muy útil.',
'Muy buen reloj despertador. Lo uso para mi hijo y funciona perfecto. La pantalla de píxeles es linda y la función de sonido es genial.',
'Me encanta! La pantalla de píxeles muestra expresiones hermosas que hacen sonreír. Responde al sonido y la lámpara es perfecta para la noche. Se agita para posponer la alarma, mi hija se divierte con eso. Es el reloj perfecto para niños sin teléfono.',
'Súper contenta con mi compra. La pantalla es adorable, muestra corazones, ojitos y hasta se ve dormido. Responde al sonido inmediatamente. La función de agitar para posponer es muy intuitiva. Mi hijo de 7 años está encantado, ya se despierta solo.',
'Excelente producto, funciona tal como lo describe. Los píxeles muestran diferentes expresiones muy tiernas. La lámpara que responde al sonido es súper práctica en las noches. Se puede agitar para posponer y eso le encanta a los niños. Muy recomendado.',
'Hermoso reloj despertador! Los ojitos de píxeles son demasiado lindos, cambian de expresión. La pantalla muestra temperatura y batería también. Responde al sonido y se puede agitar para posponer. Perfecto para mi hija que no tiene teléfono todavía.',
'La pantalla de píxeles es hermosa y las expresiones son adorables. Responde al sonido perfectamente. Funciona excelente.',
'Me encanta. Es súper tierno y funcional. Los ojitos de píxeles son preciosos. Mi hijo lo adora completamente.',
'Funciona muy bien. La pantalla muestra símbolos lindos y responde al sonido. La función de agitar es práctica.',
'Excelente compra. Es adorable, la pantalla de píxeles es hermosa. Mi hija está feliz con su relojito.',
'Súper contenta. Los píxeles son preciosos y las expresiones son tiernas. La lámpara integrada es muy útil.',
'Excelente compra. La calidad se nota desde que lo sacas de la caja. La pantalla de píxeles es hermosa y muy expresiva, muestra corazones, ojitos, temperatura. Responde al sonido instantáneamente. La función de agitar para posponer es genial. Mi hijo está encantado.',
'Muy buen producto. Lo compré para mi hijo de 9 años y funciona perfecto. Los píxeles muestran expresiones tiernas, responde al sonido y la lámpara es muy práctica. Se agita para posponer y eso lo hace más divertido. Ya se despierta solo sin problemas.',
'Me fascina! La pantalla de píxeles es preciosa y súper expresiva. Muestra diferentes caritas que entretienen a mi hija. La lámpara que responde al sonido es perfecta para la noche. Se puede agitar para posponer la alarma. Es adorable y funcional.',
'Hermoso y funcional. Los ojitos de píxeles son adorables, cambian de expresión. La función de responder al sonido lo hace interactivo. Se agita para posponer fácilmente. El diseño es precioso, perfecto para niños. Mi hija no para de jugar con él.',
'Estoy encantada con este reloj despertador. Funciona excelente, la pantalla de píxeles muestra símbolos hermosos. Responde al sonido y la lámpara es muy útil. Se agita para posponer y mi hijo lo encuentra divertido. Perfecto para que aprenda a despertarse solo.',
'Producto de muy buena calidad. La pantalla de píxeles es hermosa y clara, muestra expresiones tiernas. Responde al sonido inmediatamente. La función de agitar es práctica y divertida. El diseño es adorable, mi hija lo usa feliz todos los días.',
'Muy contento con la compra. Funciona tal como lo describe, la pantalla muestra diferentes expresiones de píxeles. Responde al sonido y la lámpara integrada es conveniente. Se puede agitar para posponer. Mi hijo ya no necesita que lo despierte, excelente.',
'Me encanta este reloj! La pantalla de píxeles es hermosa, muestra corazones, ojitos, hasta temperatura. Responde al sonido perfectamente. La función de agitar para posponer es intuitiva. Es adorable y muy funcional. Mi hija está feliz con su relojito nuevo.',
'Funciona de maravilla. Los píxeles muestran expresiones súper tiernas, mi hijo se ríe con los ojitos confundidos cuando lo agita. Responde al sonido y la lámpara es práctica. Excelente calidad, perfecto para niños que no tienen teléfono todavía.',
'Súper recomendado! La pantalla de píxeles es preciosa y muy expresiva. Muestra diferentes símbolos hermosos. Responde al sonido inmediatamente. La función de agitar para posponer la alarma es genial. Mi hija lo adora, es su compañero cada mañana.',
'Excelente producto. La pantalla de píxeles es adorable, muestra expresiones que hacen sonreír. La lámpara que responde al sonido es muy útil. Se agita para posponer fácilmente. El diseño es hermoso, perfecto para niños. Mi hijo está encantado.',
'Me fascina todo! La pantalla muestra expresiones hermosas en píxeles. Responde al sonido perfectamente. La función de agitar es divertida y práctica. Es adorable y funcional. Mi hija ya se despierta sola, estoy muy contenta con esta compra.',
'Muy buen reloj despertador. Los píxeles muestran expresiones tiernas y claras. Responde al sonido y la lámpara integrada es conveniente. Se puede agitar para posponer. El diseño es lindo, mi hijo lo usa feliz.',
'Hermoso producto! La pantalla de píxeles es preciosa, muestra corazones y ojitos adorables. Responde al sonido instantáneamente. La función de agitar es práctica. Es perfecto para niños, el diseño es encantador. Mi hija lo adora completamente.',
'Estoy muy contenta con esta compra. Funciona perfecto, la pantalla muestra símbolos lindos en píxeles. La lámpara responde al sonido. Se agita para posponer y mi hijo lo encuentra divertido. Excelente reloj para niños sin teléfono.',
'Me encanta! Los ojitos de píxeles son hermosos y expresivos. Responde al sonido inmediatamente. La función de agitar para posponer es genial. Es adorable y muy funcional. Mi hija está feliz, ya no necesita que la despierte.',
'Excelente calidad. La pantalla de píxeles es hermosa y muestra expresiones tiernas. Responde al sonido perfectamente. La lámpara integrada es útil. Se agita para posponer fácilmente. El diseño es precioso, mi hijo lo usa todos los días contento.',
'Muy buen producto. Funciona tal como lo describe, los píxeles muestran símbolos adorables. Responde al sonido y la lámpara es práctica. Se puede agitar para posponer. Es perfecto para que mi hija aprenda a despertarse sola.',
'Súper contenta! La pantalla de píxeles es hermosa, muestra expresiones que entretienen. Responde al sonido automáticamente. La función de agitar es práctica y divertida. Es adorable, mi hijo está encantado con su reloj nuevo.',
'Me fascina este reloj despertador! Los píxeles muestran expresiones súper tiernas. La lámpara responde al sonido perfectamente. Se agita para posponer la alarma. El diseño es hermoso y funcional. Mi hija lo usa feliz todos los días.',
'Hermoso producto! Funciona de maravilla, la pantalla muestra símbolos lindos en píxeles. Responde al sonido inmediatamente. La función de agitar es intuitiva. Es adorable y práctico. Mi hijo ya se despierta solo sin problemas.',
'Excelente compra. La pantalla de píxeles es preciosa y muy clara. Muestra corazones, ojitos y más. Responde al sonido. Se agita para posponer. Es perfecto para niños, el diseño es encantador. Mi hija está feliz.',
'Súper recomendado! Los ojitos de píxeles son adorables y expresivos. La lámpara que responde al sonido es útil. La función de agitar es práctica. Es hermoso y funcional. Mi hijo lo adora completamente.',
'Estoy encantada! Funciona perfecto, los píxeles muestran expresiones tiernas. Responde al sonido perfectamente. Se agita para posponer fácilmente. Es adorable, mi hija lo usa feliz. Excelente reloj para niños.',
'Hermoso y funcional. La pantalla de píxeles es hermosa, muestra símbolos lindos. Responde al sonido inmediatamente. La función de agitar es divertida. Es perfecto para mi hijo que no tiene teléfono.',
'Me fascina! Los píxeles muestran expresiones adorables que hacen sonreír. La lámpara responde al sonido. Se agita para posponer. Es hermoso y práctico. Mi hija está encantada con su relojito.',
'Excelente producto! La pantalla de píxeles es preciosa y expresiva. Responde al sonido perfectamente. La función de agitar es genial. El diseño es adorable. Mi hijo lo usa feliz todos los días.',
'Súper contenta con mi compra! Los ojitos de píxeles son hermosos. Responde al sonido automáticamente. Se agita para posponer la alarma. Es adorable y funcional. Mi hija ya se despierta sola.',
'Muy buen reloj despertador. La pantalla muestra expresiones tiernas en píxeles. La lámpara responde al sonido. Se puede agitar para posponer. Es lindo y práctico. Mi hijo está contento.',
'Me encanta! La pantalla de píxeles es hermosa, muestra corazones y ojitos. Responde al sonido perfectamente. La función de agitar es práctica. Es adorable, mi hija lo adora.',
'Hermoso producto! Los píxeles muestran expresiones súper tiernas. Responde al sonido inmediatamente. Se agita para posponer fácilmente. Es perfecto para niños. Mi hijo está encantado.',
'Funciona de maravilla! La pantalla de píxeles es preciosa y clara. La lámpara responde al sonido. Se agita para posponer. Es adorable y funcional. Mi hija lo usa feliz.',
'Estoy muy feliz con este reloj! Los ojitos de píxeles son hermosos y expresivos. Responde al sonido perfectamente. La función de agitar es genial. Es adorable, mi hijo lo adora completamente.',
'Excelente compra! La pantalla muestra símbolos lindos en píxeles. Responde al sonido automáticamente. Se agita para posponer la alarma. Es hermoso y práctico. Mi hija está feliz.',
'Muy contento con el producto. Los píxeles muestran expresiones tiernas. La lámpara responde al sonido. Se puede agitar para posponer. Es lindo y funcional. Mi hijo lo usa contento.',
'Me fascina! La pantalla de píxeles es hermosa, muestra corazones y más. Responde al sonido inmediatamente. La función de agitar es práctica. Es adorable. Mi hija lo adora.',
'Súper recomendado! Los ojitos de píxeles son preciosos y expresivos. La lámpara responde al sonido. Se agita para posponer fácilmente. Es hermoso. Mi hijo está encantado.',
'Hermoso reloj despertador! La pantalla de píxeles muestra expresiones adorables. Responde al sonido perfectamente. La función de agitar es genial. Es perfecto para niños. Mi hija lo usa feliz.',
'Estoy encantada! Los píxeles son hermosos y expresivos. La lámpara responde al sonido. Se agita para posponer. Es adorable y funcional. Mi hijo ya se despierta solo.',
'Me encanta todo! La pantalla muestra símbolos preciosos en píxeles. Responde al sonido automáticamente. La función de agitar es práctica. Es hermoso. Mi hija está feliz.',
'Muy buen producto. Los ojitos de píxeles son adorables. La lámpara responde al sonido. Se puede agitar para posponer. Es lindo y funcional. Mi hijo lo adora.',
'Excelente compra! La pantalla de píxeles es hermosa y clara. Responde al sonido perfectamente. Se agita para posponer fácilmente. Es adorable. Mi hija lo usa contenta.',
'Súper contenta! Los píxeles muestran expresiones tiernas. La lámpara responde al sonido. La función de agitar es genial. Es hermoso y práctico. Mi hijo está encantado.',
'Me fascina este reloj! La pantalla de píxeles es preciosa. Responde al sonido inmediatamente. Se agita para posponer. Es adorable y funcional. Mi hija lo adora.',
'Hermoso producto! Los ojitos de píxeles son hermosos. La lámpara responde al sonido. La función de agitar es práctica. Es perfecto para niños. Mi hijo está feliz.',
'Estoy muy feliz con mi compra! La pantalla muestra expresiones lindas en píxeles. Responde al sonido perfectamente. Se agita para posponer. Es adorable. Mi hija lo usa contenta.',
'Excelente producto! Los píxeles son hermosos y expresivos. La lámpara responde al sonido. La función de agitar es genial. Es hermoso y funcional. Mi hijo lo adora.',
'Me encanta! La pantalla de píxeles muestra símbolos adorables. Responde al sonido automáticamente. Se agita para posponer fácilmente. Es precioso. Mi hija está encantada.',
'Muy contento con la compra. Los ojitos de píxeles son lindos. La lámpara responde al sonido. Se puede agitar para posponer. Es funcional y adorable. Mi hijo lo usa feliz.',
'Súper recomendado! La pantalla de píxeles es hermosa. Responde al sonido perfectamente. La función de agitar es práctica. Es adorable para niños. Mi hija lo adora.',
'Hermoso reloj! Los píxeles muestran expresiones tiernas. La lámpara responde al sonido. Se agita para posponer. Es lindo y funcional. Mi hijo está contento.',
'Estoy encantada! La pantalla de píxeles es preciosa. Responde al sonido inmediatamente. La función de agitar es genial. Es adorable. Mi hija lo usa feliz.',
'Me fascina todo! Los ojitos de píxeles son hermosos. La lámpara responde al sonido. Se agita para posponer fácilmente. Es perfecto. Mi hijo lo adora.',
'Muy buen producto. La pantalla muestra símbolos lindos en píxeles. Responde al sonido perfectamente. Se puede agitar para posponer. Es adorable. Mi hija está feliz.',
'Excelente compra! Los píxeles son hermosos y expresivos. La lámpara responde al sonido. La función de agitar es práctica. Es precioso. Mi hijo lo usa contento.',
'Súper contenta! La pantalla de píxeles es adorable. Responde al sonido automáticamente. Se agita para posponer. Es hermoso y funcional. Mi hija lo adora.',
'Me encanta este reloj! Los ojitos de píxeles son preciosos. La lámpara responde al sonido. La función de agitar es genial. Es adorable. Mi hijo está encantado.',
'Hermoso producto! La pantalla muestra expresiones tiernas en píxeles. Responde al sonido perfectamente. Se agita para posponer fácilmente. Es lindo. Mi hija lo usa feliz.',
'Estoy muy feliz! Los píxeles son hermosos y claros. La lámpara responde al sonido. La función de agitar es práctica. Es adorable y funcional. Mi hijo lo adora.',
'Excelente producto! La pantalla de píxeles muestra símbolos lindos. Responde al sonido inmediatamente. Se agita para posponer. Es precioso para niños. Mi hija está contenta.',
'Me fascina! Los ojitos de píxeles son adorables. La lámpara responde al sonido. La función de agitar es genial. Es hermoso y práctico. Mi hijo lo usa feliz.',
'Muy contento con el producto. La pantalla de píxeles es hermosa. Responde al sonido perfectamente. Se puede agitar para posponer. Es adorable. Mi hija lo adora.',
'Súper recomendado! Los píxeles muestran expresiones tiernas. La lámpara responde al sonido. Se agita para posponer fácilmente. Es lindo y funcional. Mi hijo está encantado.',
'Hermoso reloj despertador! La pantalla de píxeles es preciosa. Responde al sonido automáticamente. La función de agitar es práctica. Es adorable. Mi hija lo usa contenta.',
'Estoy encantada! Los ojitos de píxeles son hermosos. La lámpara responde al sonido. Se agita para posponer. Es perfecto para niños. Mi hijo está feliz.',
'Me encanta todo! La pantalla muestra símbolos adorables en píxeles. Responde al sonido perfectamente. La función de agitar es genial. Es precioso. Mi hija lo adora.',
'Muy buen producto. Los píxeles son hermosos y expresivos. La lámpara responde al sonido. Se puede agitar para posponer. Es adorable y funcional. Mi hijo lo usa contento.',
'Excelente compra! La pantalla de píxeles es hermosa. Responde al sonido inmediatamente. Se agita para posponer fácilmente. Es lindo. Mi hija está encantada.',
'Súper contenta! Los ojitos de píxeles son preciosos. La lámpara responde al sonido. La función de agitar es práctica. Es adorable. Mi hijo lo adora.',
'Me fascina este reloj! La pantalla muestra expresiones tiernas en píxeles. Responde al sonido perfectamente. Se agita para posponer. Es hermoso. Mi hija lo usa feliz.',
'Hermoso producto! Los píxeles son adorables y claros. La lámpara responde al sonido. La función de agitar es genial. Es perfecto para niños. Mi hijo está contento.',
'Estoy muy feliz con mi compra! La pantalla de píxeles muestra símbolos lindos. Responde al sonido automáticamente. Se agita para posponer. Es adorable. Mi hija lo adora.',
'Excelente producto! Los ojitos de píxeles son hermosos. La lámpara responde al sonido. La función de agitar es práctica. Es precioso y funcional. Mi hijo lo usa feliz.',
'Me encanta! La pantalla de píxeles es hermosa. Responde al sonido perfectamente. Se puede agitar para posponer. Es adorable para niños. Mi hija está encantada.',
'Muy contento con el producto. Los píxeles muestran expresiones tiernas. La lámpara responde al sonido. Se agita para posponer fácilmente. Es lindo. Mi hijo lo adora.',
'Súper recomendado! La pantalla de píxeles es preciosa. Responde al sonido inmediatamente. La función de agitar es genial. Es adorable y funcional. Mi hija lo usa contenta.',
'Hermoso reloj! Los ojitos de píxeles son adorables. La lámpara responde al sonido. Se agita para posponer. Es perfecto. Mi hijo está feliz.',
'Estoy encantada! La pantalla muestra símbolos lindos en píxeles. Responde al sonido perfectamente. La función de agitar es práctica. Es precioso. Mi hija lo adora.',
'Me fascina todo! Los píxeles son hermosos y expresivos. La lámpara responde al sonido. Se agita para posponer fácilmente. Es adorable. Mi hijo lo usa contento.',
'Muy buen producto. La pantalla de píxeles es hermosa. Responde al sonido automáticamente. Se puede agitar para posponer. Es lindo y funcional. Mi hija está encantada.',
'Excelente compra! Los ojitos de píxeles son preciosos. La lámpara responde al sonido. La función de agitar es genial. Es adorable para niños. Mi hijo lo adora.',
'Súper contenta! La pantalla muestra expresiones tiernas en píxeles. Responde al sonido perfectamente. Se agita para posponer. Es hermoso. Mi hija lo usa feliz.',
'Me encanta este reloj! Los píxeles son adorables y claros. La lámpara responde al sonido. La función de agitar es práctica. Es precioso. Mi hijo está contento.',
'Hermoso producto! La pantalla de píxeles muestra símbolos lindos. Responde al sonido inmediatamente. Se agita para posponer fácilmente. Es adorable. Mi hija lo adora.',
'Estoy muy feliz! Los ojitos de píxeles son hermosos. La lámpara responde al sonido. La función de agitar es genial. Es perfecto y funcional. Mi hijo lo usa feliz.'
];

//------------------------------------------------------------
// DETECTAR SI ESTAMOS EN /es  (versión en español)
//------------------------------------------------------------
const isSpanish = window.location.pathname.startsWith("/es");

//------------------------------------------------------------
// ELEGIR QUÉ LISTAS USAR SEGÚN EL IDIOMA
//------------------------------------------------------------
const finalNames = isSpanish ? namesES : names;
const finalTexts = isSpanish ? baseTextsES : baseTexts;
const finalRelief = isSpanish ? ["Muy bueno", "Excelente"] : ["Very good", "Excellent"];

//------------------------------------------------------------
// CREAR LAS REVIEWS USANDO LAS LISTAS CORRECTAS
//------------------------------------------------------------
const totalReviews = 127;

window.kamiluneReviews = Array.from({ length: totalReviews }, (_, i) => {
  const idx = i + 1;

  return {
    id: idx,
    name: finalNames[i % finalNames.length],
    verified: true,
    verifiedText: isSpanish ? "Comprador Verificado🛡️" : "Verified Buyer🛡️",
    age: ["18-24", "25-34", "35-44", "45-54", "55+"][i % 5],
    relief: finalRelief[i % 2],
    stars: i < 13 ? 4 : 5,
    text: finalTexts[i % finalTexts.length],
    photo: idx <= 29 ? photoList[idx - 1] : null
  };
});

// -----------------------------------------------
// Resto del código idéntico al tuyo (render, filtros, paginación)
// -----------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const reviews = window.kamiluneReviews;

  const containerEl = document.getElementById('kr-reviews-container');
  const paginationEl = document.getElementById('kr-pagination');
  const searchInput = document.getElementById('kr-search');
  const photoFilter = document.getElementById('kr-photo-filter');
  const starsFilter = document.getElementById('kr-stars-filter');

  let currentPage = 1;

  function getFilteredReviews() {
    const search = (searchInput?.value || '').toLowerCase();
    const photo = photoFilter?.value || 'all';
    const stars = starsFilter?.value || 'all';

    return reviews.filter(r => {
      if (photo === 'with' && !r.photo) return false;
      if (photo === 'without' && r.photo) return false;
      if (stars !== 'all' && r.stars !== Number(stars)) return false;

      const haystack = `${r.name} ${r.text}`.toLowerCase();
      if (search && !haystack.includes(search)) return false;

      return true;
    });
  }

  function createStars(count) {
    let html = '';
    for (let i = 0; i < 5; i++) {
      html += `<span class="kr-star ${i < count ? 'kr-star--filled' : ''}">★</span>`;
    }
    return html;
  }

  function renderReviews() {
    const filtered = getFilteredReviews();
    const start = (currentPage - 1) * KR_REVIEWS_PER_PAGE;
    const slice = filtered.slice(start, start + KR_REVIEWS_PER_PAGE);

    if (!slice.length) {
      containerEl.innerHTML = '<p>No reviews match your filters.</p>';
      return;
    }

    containerEl.innerHTML = slice.map(r => `
    <div class="kr-review">

      <div class="kr-review-header">
        <div>
          <strong>${r.name}</strong>
          <span class="kr-review-verified">${r.verifiedText}</span>
        </div>
      </div>

      <p class="kr-review-text">${r.text}</p>

      <div class="kr-stars">${createStars(r.stars)}</div>

      ${r.photo ? `<img src="${r.photo}" class="kr-review-photo" />` : ''}

    </div>
`).join('');

    renderPagination(filtered.length);
  }

  function renderPagination(total) {
  const totalPages = Math.ceil(total / KR_REVIEWS_PER_PAGE);
  let html = "";

  if (totalPages <= 1) {
    paginationEl.innerHTML = "";
    return;
  }

  const maxBtns = 3;

  // Rango dinámico centrado
  let start = currentPage - Math.floor(maxBtns / 2);
  let end = start + maxBtns - 1;

  // Evitar valores invalidos
  if (start < 1) {
    start = 1;
    end = Math.min(maxBtns, totalPages);
  }

  if (end > totalPages) {
    end = totalPages;
    start = Math.max(1, end - maxBtns + 1);
  }

  // Prev
  html += `<button class="kr-pagination-btn" data-page="prev" ${currentPage === 1 ? "disabled" : ""}>&lt;</button>`;

  // Pages
  for (let p = start; p <= end; p++) {
    html += `
      <button class="kr-pagination-btn ${p === currentPage ? "kr-pagination-btn--active" : ""}" data-page="${p}">
        ${p}
      </button>
    `;
  }

  // Next
  html += `<button class="kr-pagination-btn" data-page="next" ${currentPage === totalPages ? "disabled" : ""}>&gt;</button>`;

  paginationEl.innerHTML = html;

  // Event listeners
  paginationEl.querySelectorAll(".kr-pagination-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const val = btn.getAttribute("data-page");

      if (val === "prev" && currentPage > 1) currentPage--;
      else if (val === "next" && currentPage < totalPages) currentPage++;
      else if (!isNaN(parseInt(val))) currentPage = parseInt(val);

      renderReviews();
    });
  });
}



  [searchInput, photoFilter, starsFilter].forEach(el =>
    el?.addEventListener('input', () => {
      currentPage = 1;
      renderReviews();
    })
  );

  renderReviews();
});
